import { partialScore } from './partialScore';
export function exploreTree(props, infoByAtomTypes, partial, store) {
    const { currentAtomTypes, restrictionByCS, timeout, timeStart, maxSolutions, targets, predictions, correlations, lowerBoundScore, possibleAssignmentMap, diaIDPeerPossibleAssignment, } = props;
    if (Date.now() - timeStart > timeout) {
        new Error('timeout expired');
        return store;
    }
    for (const atomType of currentAtomTypes) {
        const { currentIndex, nSources } = infoByAtomTypes[atomType];
        if (currentIndex >= nSources - 1 &&
            partial[atomType][currentIndex] !== null) {
            continue;
        }
        const diaID = diaIDPeerPossibleAssignment[atomType][currentIndex];
        const possibleAssignments = possibleAssignmentMap[atomType][diaID];
        for (let targetID of possibleAssignments) {
            partial[atomType][currentIndex] = targetID;
            let score = partialScore(partial, {
                diaIDPeerPossibleAssignment,
                infoByAtomTypes,
                restrictionByCS,
                predictions,
                correlations,
                targets,
            });
            if (score === 0) {
                continue;
            }
            if (isLastOne(currentAtomTypes, infoByAtomTypes) &&
                score >= lowerBoundScore) {
                addSolution(store, { predictions, partial, score, maxSolutions });
            }
            else {
                const newInfo = JSON.parse(JSON.stringify(infoByAtomTypes));
                newInfo[atomType].currentIndex += 1;
                exploreTree({
                    currentAtomTypes,
                    restrictionByCS,
                    timeout,
                    timeStart,
                    maxSolutions,
                    targets,
                    predictions,
                    correlations,
                    lowerBoundScore,
                    possibleAssignmentMap,
                    diaIDPeerPossibleAssignment,
                }, newInfo, JSON.parse(JSON.stringify(partial)), store);
            }
        }
    }
}
function addSolution(store, props) {
    let { score, maxSolutions, partial, predictions } = props;
    score /= doubleAssignmentPenalty(partial, predictions);
    let solution = {
        assignment: JSON.parse(JSON.stringify(partial)),
        score,
    };
    if (store.nSolutions >= maxSolutions) {
        if (solution.score > store.solutions.last().score) {
            store.solutions.pollLast();
            store.solutions.add(solution);
        }
    }
    else {
        store.solutions.add(solution);
        store.nSolutions++;
    }
}
function isLastOne(currentAtomTypes, infoByAtomTypes) {
    let lastOne = true;
    for (const atomType of currentAtomTypes) {
        const { currentIndex, nSources } = infoByAtomTypes[atomType];
        lastOne = lastOne && currentIndex >= nSources - 1;
    }
    return lastOne;
}
function doubleAssignmentPenalty(partial, predictions) {
    let nbDoubleAssignment = 0;
    for (const atomType in predictions) {
        const nbSources = Object.keys(predictions[atomType]).length;
        let assignments = new Set(partial[atomType]);
        nbDoubleAssignment += nbSources - assignments.size;
    }
    return nbDoubleAssignment > 0 ? 2 * nbDoubleAssignment : 1;
}
//# sourceMappingURL=exploreTree.js.map